<template>
    <div class="newsletter-action" :class="{ 'newsletter-action--triggered': open }" v-if="! hasCookie">
        <div class="newsletter-action__button" @click="reveal">
            <div class="newsletter-action__button__overlay">
                {{ helpers.getTranslation(translations, 'widget-button-text') }}&nbsp;<span class="icon-arrow"><img src="/site/img/arrow_3.svg" alt=""></span>
            </div>
        </div>
        <div class="newsletter-action__container" ref="action_container">
            <div class="newsletter-action__container-align">
                <div class="newsletter-action__container__gradient" ref="gradient_container">
                <canvas id="newsletter-canvas" ref="newsletter_gradient" class="newsletter-gradient"></canvas>
            </div>
                <div class="newsletter-action__content">

                    <div class="newsletter-action__content__header-buttons">
                        <span class="menu--arrow-back"><img src="/site/img/arrow_3.svg" alt=""></span>

                        <a href="#" class="menu--cross" @click="close">
                            <span class="line"></span><!-- /.line -->
                            <span class="line"></span><!-- /.line -->
                        </a>
                    </div>
                    <div class="newsletter-action__content__interaction">

                        <transition name="slide" mode="out-in">
                            <component
                                :is="slide"
                                :email="email"
                                :subscription-confirmed="subscriptionConfirmed"
                                :translations="translations"
                                v-on:change-component="changeComponent"
                                v-on:close="close"
                                v-on:set-email="setEmail">
                            </component>
                        </transition>

                    </div>

                </div>
            </div>
        </div>
        <div class="newsletter-action__overlay" @click="close"></div>
    </div>

</template>

<script>

    import helpers from 'assets/js/site/helpers';
    import Config from 'assets/js/site/_site-config';
    import Granim from 'granim';
    import SubscribeSlide from './subscribe-slide';
    import TourIntroSlide from './tour-intro-slide';
    import PreferencesSlide from './prefrences-slide';
    import ThankYouForSubscribingSlide from './thanks-for-subscribing-slide';

    import CookieMixin from './mixins/cookies';

    const waitForMilliseconds = function(ms) {

        return new Promise((resolve, reject) => {
            let wait = setTimeout(() => {
                clearTimeout(wait);
                resolve('Finished');
            }, ms)
        });
    };

    export default {
        mixins: [CookieMixin],

        data: () => ({
            helpers: helpers,
            open: false,
            email: null,
            gradientAnimation: null,
            slide: 'alf-newsletter-subscribe-slide'
        }),

        components: {
            'alf-tour-intro-slide': TourIntroSlide,
            'alf-newsletter-subscribe-slide': SubscribeSlide,
            'alf-newsletter-preferences-slide': PreferencesSlide,
            'alf-newsletter-thanks-for-subscribing-slide': ThankYouForSubscribingSlide
        },

        props: {
            showExtended: Boolean,
            openPopup: Boolean,
            translations: { required: true },
            subscriptionConfirmed: {Boolean, required: false, default: false}
        },

        mounted: function () {
            window.addEventListener('triggerReveal', this.reveal);

            if(this.openPopup) {
                setTimeout(function () {
                    self.reveal();
                }, 900);
            }

            if(this.hasCookie) return;

            const self = this;
            this.initializeGradient();
            this.registerEventHandlers();

            // Show the extended form when we're on a page where we want to show it, being extended
            if(this.showExtended) {
                this.slide = 'alf-tour-intro-slide';

                document.addEventListener('DOMContentLoaded', function() {
                    setTimeout(function () {
                        self.reveal();
                    }, 900);
                });
            } else {
                // Else, show it automatically after 30 seconds, if it already hasn't shown before.
                document.addEventListener('DOMContentLoaded', function() {

                    // Call doSomething and receive a Promise as return
                    let autoShowTimeoutResponse = waitForMilliseconds(30000);

                    // Wait for the promise to get resolved...
                    autoShowTimeoutResponse.then(response => {
                        // If the widget is already shown, do not reveal again.
                        if (!localStorage.newsletter_widget_has_been_shown)
                            self.reveal();
                    });
                });
            }

            // Show the thank you slide
            if(this.subscriptionConfirmed) {
                this.slide = "alf-newsletter-thanks-for-subscribing-slide";

                document.addEventListener("DOMContentLoaded", function() {

                    setTimeout(function () {
                        self.reveal();
                    }, 900);
                })
            }
        },

        methods: {
            changeComponent: function(payload)
            {
                this.slide = `alf-newsletter-${payload.slide_name}-slide`;
            },

            setEmail: function(email)
            {
                this.email = email;
            },

            reveal: function() {
                // On click, do not auto extend anymore.
                if (typeof(Storage) !== "undefined" && !localStorage.newsletter_widget_has_been_shown)
                    localStorage.newsletter_widget_has_been_shown = true;

                this.open = true;
                this.gradientAnimation.pause();
                // document.body.style.overflowY = "hidden"; // this causes a bug in IE, as it doesn't remove its prefixed variant and unset is not supported
                document.body.classList.add("overflow-hidden");
            },

            close: function() {
                this.open = false;
                this.gradientAnimation.play();
                document.body.classList.remove("overflow-hidden");
            },

            initializeGradient: function() {
                this.gradientAnimation = new Granim({
                    element: this.$refs.newsletter_gradient,
                    name: 'granim',
                    direction: 'top-bottom', // 'diagonal', 'top-bottom'
                    opacity: [1, 1, 1],
                    isPausedWhenNotInView: true,
                    scrollDebounceThreshold: 300,
                    states : {
                        "default-state": {
                            gradients: Config.gradients,
                            transitionSpeed: 2000,
                            loop: true
                        }
                    }
                })
            },

            registerEventHandlers: function() {
                const pressEscapeCallback = this.close;

                // document.body.addEventListener("keydown", function (e) {
                //     if(e.key === "Escape" || e.key === "Esc")
                //         pressEscapeCallback();
                // });
            },
        },

        computed: {
            loadingGradient: function() {
                const gradient = Config.gradients[0];

                return {
                    "background": `linear-gradient(${gradient[0]}, ${gradient[1]}, ${gradient[2]})`
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .slide-leave-active {
        transition: .8s cubic-bezier(.93,.02,.19,1);
    }
    .slide-enter-active {
        transition: 1s cubic-bezier(0,1,.75,1);
    }
    .slide-enter {
        transform: translate(100%, 0);
    }
    .slide-leave-to {
        transform: translate(-100%, 0);
    }

    .cookie-newsletter-subscribed {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/newsletter-widget/newsletter-widget-root.vue